import { Aggregator } from "../types";

export class PdfRangeCollector implements Aggregator<number[]>  {
    private pagesRange: number[][] = [];
    private currentIndex = 0;

    private readonly RANGE_LIMIT = 6;

    public add(item?: number[]): void {
        if(item) {
            this.pagesRange.push(item);
        }
    }

    public getCurrent(): number[] {
        if(this.pagesRange[this.currentIndex].length > 0) {
            return this.pagesRange[this.currentIndex];
        };
    }

    public setNext(): void {
        this.currentIndex++;
    }

    public getRanges(): number[][] {
        return this.pagesRange;
    }

    public hasNextRange(): boolean {
        return this.pagesRange[this.currentIndex + 1]?.length > 0;
    }

    public createRanges(pages: number): void {
        const start = 1;
        const end = pages;

        let fullRange = [...Array(end - start + 1).keys()].map(x => x + start);
        fullRange = fullRange.filter(pg => !this.pagesRange[0].includes(pg));

        while(fullRange.length) {
            this.pagesRange.push(fullRange.splice(0, this.RANGE_LIMIT));
        }
    }
}